module.exports = __webpack_public_path__ + "img/ES3098.e3e2bbb3.png";